module.exports = __webpack_public_path__ + "static/media/3.ce7f8263.gif";